import type { RootState } from '../store.ts';
import type { TCertificateGenerationType } from '~/store/covenants/types.ts';

const select = (s: RootState) => s.covenants;

export const selectAccessToken = (s: RootState) => s.users.token;
export const selectAccessDeniedModal = (s: RootState) => select(s).accessDeniedModal;

export const selectCurrentContragent = (s: RootState) => select(s).currentContragent.data;
export const selectCurrentContragentStatus = (s: RootState) => select(s).currentContragent.status;
export const selectCurrentContragentError = (s: RootState) => select(s).currentContragent.error;
export const selectSupervisorContragentBlocksResponse = (s: RootState) =>
  select(s).supervisorContragentBlocks.data;
export const selectSupervisorContragentBlocks = (s: RootState) =>
  select(s).supervisorContragentBlocks.data?.blocks ?? [];
export const selectSupervisorContragentBlocksPageConfiguration = (s: RootState) =>
  select(s).supervisorContragentBlocks.data?.pageConfiguration ?? {
    page: 0,
    size: 10,
    totalElements: 0,
  };
export const selectSupervisorContragentBlocksStatus = (s: RootState) =>
  select(s).supervisorContragentBlocks.status;
export const selectSupervisorContragentBlocksError = (s: RootState) =>
  select(s).supervisorContragentBlocks.error;

export const selectRequiredDocumentsResponse = (s: RootState) => select(s).requiredDocuments.data;
export const selectRequiredDocuments = (s: RootState) =>
  select(s).requiredDocuments.data?.requiredDocuments ?? [];
export const selectRequiredDocumentsPageConfiguration = (s: RootState) =>
  select(s).requiredDocuments.data?.pageConfiguration ?? { page: 0, size: 10, totalElements: 0 };
export const selectRequiredDocumentsStatus = (s: RootState) => select(s).requiredDocuments.status;
export const selectRequiredDocumentsError = (s: RootState) => select(s).requiredDocuments.error;

export const selectCovenants = (s: RootState) => select(s).covenants.data?.covenants ?? [];
export const selectCovenantsPageConfiguration = (s: RootState) =>
  select(s).covenants.data?.pageConfiguration ?? { page: 0, size: 5, totalElements: 0 };
export const selectCovenantsStatus = (s: RootState) => select(s).covenants.status;
export const selectCovenantsError = (s: RootState) => select(s).covenants.error;

export const selectApplicationsResponse = (s: RootState) => select(s).applications.data;
export const selectApplications = (s: RootState) => select(s).applications.data?.applications ?? [];
export const selectApplicationsPageConfiguration = (s: RootState) =>
  select(s).applications.data?.pageConfiguration ?? { page: 0, size: 10, totalElements: 0 };
export const selectApplicationsStatus = (s: RootState) => select(s).applications.status;
export const selectApplicationsError = (s: RootState) => select(s).applications.error;
export const selectActiveApplicationsResponse = (s: RootState) => select(s).activeApplications.data;
export const selectActiveApplications = (s: RootState) =>
  select(s).activeApplications.data?.applications ?? [];
export const selectActiveApplicationsPageConfiguration = (s: RootState) =>
  select(s).activeApplications.data?.pageConfiguration ?? { page: 0, size: 4, totalElements: 0 };
export const selectActiveApplicationsStatus = (s: RootState) => select(s).activeApplications.status;
export const selectActiveApplicationsError = (s: RootState) => select(s).activeApplications.error;

export const selectSupervisorSegments = (s: RootState) => select(s).supervisorSegments.data ?? [];
export const selectSupervisorSegmentsStatus = (s: RootState) => select(s).supervisorSegments.status;
export const selectSupervisorSegmentsError = (s: RootState) => select(s).supervisorSegments.error;
export const selectSupervisorDocumentTemplates = (s: RootState) =>
  select(s).supervisorDocumentTemplates.data;
export const selectSupervisorDocumentTemplatesStatus = (s: RootState) =>
  select(s).supervisorDocumentTemplates.status;
export const selectSupervisorDocumentTemplatesError = (s: RootState) =>
  select(s).supervisorDocumentTemplates.error;

export const selectSupervisorApplicationsResponse = (s: RootState) =>
  select(s).supervisorApplications.data;
export const selectSupervisorApplications = (s: RootState) =>
  select(s).supervisorApplications.data?.supervisorApplications ?? [];
export const selectSupervisorApplicationsPageConfiguration = (s: RootState) =>
  select(s).supervisorApplications.data?.pageConfiguration ?? {
    page: 0,
    size: 10,
    totalElements: 0,
  };
export const selectSupervisorApplicationsStatus = (s: RootState) =>
  select(s).supervisorApplications.status;
export const selectSupervisorApplicationsError = (s: RootState) =>
  select(s).supervisorApplications.error;
export const selectSupervisorReadyCovenantsResponse = (s: RootState) =>
  select(s).supervisorReadyCovenants.data;
export const selectSupervisorReadyCovenants = (s: RootState) =>
  select(s).supervisorReadyCovenants.data?.covenants ?? [];
export const selectSupervisorReadyCovenantsPageConfiguration = (s: RootState) =>
  select(s).supervisorReadyCovenants.data?.pageConfiguration ?? {
    page: 0,
    size: 10,
    totalElements: 0,
  };
export const selectSupervisorReadyCovenantsStatus = (s: RootState) =>
  select(s).supervisorReadyCovenants.status;
export const selectSupervisorReadyCovenantsError = (s: RootState) =>
  select(s).supervisorReadyCovenants.error;

export const selectCurrentSupervisorApplication = (s: RootState) =>
  select(s).currentSupervisorApplication.data;
export const selectCurrentSupervisorApplicationStatus = (s: RootState) =>
  select(s).currentSupervisorApplication.status;
export const selectCurrentSupervisorApplicationError = (s: RootState) =>
  select(s).currentSupervisorApplication.error;

export const selectSupervisorApplicationDocumentsResponse = (s: RootState) =>
  select(s).supervisorApplicationDocuments.data;
export const selectSupervisorApplicationDocuments = (s: RootState) =>
  select(s).supervisorApplicationDocuments.data?.documents ?? [];
export const selectSupervisorApplicationDocumentsPageConfiguration = (s: RootState) =>
  select(s).supervisorApplicationDocuments.data?.pageConfiguration ?? {
    page: 0,
    size: 10,
    totalElements: 0,
  };
export const selectSupervisorApplicationDocumentsStatus = (s: RootState) =>
  select(s).supervisorApplicationDocuments.status;
export const selectSupervisorApplicationDocumentsError = (s: RootState) =>
  select(s).supervisorApplicationDocuments.error;

export const selectCurrentApplication = (s: RootState) => select(s).currentApplication.data;
export const selectCurrentApplicationStatus = (s: RootState) => select(s).currentApplication.status;

export const selectApplicationDocumentsResponse = (s: RootState) =>
  select(s).applicationDocuments.data;
export const selectApplicationDocuments = (s: RootState) =>
  select(s).applicationDocuments.data?.applicationDocuments ?? [];
export const selectApplicationDocumentsPageConfiguration = (s: RootState) =>
  select(s).applicationDocuments.data?.pageConfiguration ?? { page: 0, size: 10, totalElements: 0 };
export const selectApplicationDocumentsStatus = (s: RootState) =>
  select(s).applicationDocuments.status;
export const selectApplicationDocumentsError = (s: RootState) =>
  select(s).applicationDocuments.error;
export const selectApplicationUnsignedDocumentsCount = (s: RootState) =>
  select(s).applicationUnsignedDocumentsCount.data;

export const selectDocumentGenerationBanks = (s: RootState) =>
  select(s).documentGenerationBanks.data;
export const selectDocumentGenerationBanksStatus = (s: RootState) =>
  select(s).documentGenerationBanks.status;
export const selectDocumentGenerationBanksError = (s: RootState) =>
  select(s).documentGenerationBanks.error;
export const selectDocumentGenerationCurrencies = (s: RootState) =>
  select(s).documentGenerationCurrencies.data;
export const selectDocumentGenerationCurrenciesStatus = (s: RootState) =>
  select(s).documentGenerationCurrencies.status;
export const selectDocumentGenerationCurrenciesError = (s: RootState) =>
  select(s).documentGenerationCurrencies.error;

export const selectCertificateGeneration =
  (certificateType: TCertificateGenerationType) => (s: RootState) =>
    select(s).certificateGeneration[certificateType];
